export var queryKeys = {
    // the key is static and doesn't have any identifiers
    // because at this point it always follows the data from checkUser function.
    // once the query becomes independent, the key will need to consider the token, active shop, active barber
    currentSession: function () { return ['session']; },
};
